// Keep labels aligned with getMainMenuItems() in Sidebar.jsx.
export const SIGNUP_PREVIEW_PRIMARY_ITEMS = [
  'Home',
  'Chats',
  'Boards',
  'Inbox',
  'Tables',
];

export const SIGNUP_PREVIEW_RESOURCE_ITEMS = [
  'Agents',
  'Teams',
  'Workflows',
  'Files',
  'Artifacts',
  'Docs',
  'Secrets',
  'Custom Functions',
  'Forms',
  'MCP Servers',
  'Humans',
  'Trash',
  'More',
];

